import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import bundle from './locales-bundle.json';

// Single source of truth for languages and namespaces.
// Locales are pre-aggregated into locales-bundle.json (one import = one request),
// avoiding 240 parallel requests that overwhelmed the dev server cold start.
// Regenerate with: node scripts/bundle-locales.mjs (whenever locales/*/*.json change)
const NS_KEYS = ['common','navigation','hero','dashboard','auth','settings','analysis','errors','copilot','radar','journal','picks','profile','about','contact','gameDetails'] as const;

const resources = bundle as Record<string, Record<string, any>>;

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en', // Force English as default language
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [...NS_KEYS],

    interpolation: {
      escapeValue: false, // React already escapes
    },

    detection: {
      order: ['localStorage'], // Only use localStorage, no browser detection
      caches: ['localStorage'],
      lookupLocalStorage: 'sg7-language',
    },

    react: {
      useSuspense: true, // Enable Suspense for async loading
    },
  });

export default i18n;
